angular.module('dnecom')
    .controller('PromoCodesController', ["$scope", "wizardModal", "$http", "$timeout", "notifications", "$location", "DTOptionsBuilder", function PromoCodesController($scope, wizardModal, $http, $timeout, notifications, $location, DTOptionsBuilder) {
        $scope.store = TemplateData.value('store');

        $scope.dtPromoCodesTableInstance = {};

        $scope.dtPromoCodesTableOptions =  DTOptionsBuilder.newOptions().withOption('aaSorting', [[1, 'desc'], [0, 'asc']]);

        $scope.dtPromoCodesColumnDefs = [
            {
                targets: [3, 5],
                orderable: false
            }
        ];

        $scope.promoCodes = [];
        $scope.promoCodeTypes = {percent: '% discount', fixed: 'Exact $ amount', free_shipping: 'Free Ship'};
        $scope.loading = false;

        $scope.loadPromoCodes = function() {
            $scope.loading = true;

            $http
                .get(Routing.generate('promocodes_get', {
                    id: $scope.store.id
                }))
                .success(function(data) {
                    if (!data.hasOwnProperty('promoCodes')) {
                        notifications.danger(response.data.message);
                        return;
                    }

                    $scope.promoCodes = data.promoCodes;
                })
                .finally(function() {
                    $scope.$emit('datatable.updated');
                    $scope.loading = false;
                })
            ;
        };

        $scope.getEditUrl = function(promoCode) {
            return Routing.generate('promocodes_process', {id: $scope.store.id, promoCodeId: promoCode.id});
        };

        $scope.deletePromoCode = function(promoCode) {
            $http
                .delete(Routing.generate('promocodes_delete', {
                    id: $scope.store.id,
                    promoCodeId: promoCode.id
                }))
                .success(function(response) {
                    if (!response.success) {
                        notifications.danger(response.message);
                        return;
                    }

                    notifications.success('Promo code deleted.');
                    $scope.loadPromoCodes();
                })
                .error(function(response) {
                    notifications.danger('Request error.');
                })
            ;
        };

        $scope.loadPromoCodes();
    }])
;
